import styled from 'styled-components';
import { colors } from 'pages/new-questions/styles/common';

export const SplitLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(320px, 1fr);
  gap: 24px;
  width: 100%;
  align-items: flex-start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const ContextCard = styled.div`
  border-radius: 16px;
  padding-right: 24px;
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1100px) {
    max-height: none;
    padding-right: 0;
  }
`;

export const PanelCard = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.borderGray};
  border-radius: 16px;
  padding: 20px 20px 16px;
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.02);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
